/**
 * LA RÉPONSE EN UNE PHRASE (proposé, non demandé) : à quelle distance est le
 * plus proche. C'est la question qui décide de « gonfler » le devis, et la
 * carte seule oblige à la mesurer à l'œil. Rien tant que la liste affichée ne
 * correspond pas au rayon choisi.
 */
export function resumeDeLaCarte({ formateurs, rayon, aJour }) {
  if (!aJour) return null
  if (!formateurs.length) return `Aucun formateur dans un rayon de ${rayon} km : élargissez la distance.`
  const nombre = formateurs.length > 1 ? `${formateurs.length} formateurs` : 'un formateur'
  const distances = formateurs.map((f) => f.distanceKm).filter((d) => d != null)
  if (!distances.length) return `${nombre[0].toUpperCase()}${nombre.slice(1)} dans un rayon de ${rayon} km.`
  return `Le plus proche est à ${Math.round(Math.min(...distances))} km — ${nombre} dans un rayon de ${rayon} km.`
}
